import angular from 'angular';

/* eslint indent: "off" */
const userInTeamService = angular.module('ttb.services.configuration.userInTeam.service', [])
  .factory('userInTeamService', ['$q', '$http',
    ($q, $http) => {
      const url = '/api/configuration/user-in-team';

      const getUsers = (filter) => {
        const { q, teamId } = filter || {};
        return $q((resolve, reject) => {
          $http.get(`${url}/users`, { params: { q, teamId } })
            .then((response) => {
              if (DEBUG) {
                console.log(response);
              }
              resolve(response.data);
            }, reject);
        });
      };

      const getTeams = (filter) => {
        const { q, userId, groupId } = filter || {};
        return $q((resolve, reject) => {
          $http.get(`${url}/teams`, { params: { q, userId, groupId } })
            .then((response) => {
              if (DEBUG) {
                console.log(response);
              }
              resolve(response.data);
            }, reject);
        });
      };


      const get = ({ userId, teamId }) => $q((resolve, reject) => {
        $http.get(url, { params: { userId, teamId } })
          .then((response) => {
            if (DEBUG) {
              console.log(response);
            }
            resolve(response.data);
          }, reject);
      });

      const update = ({
        userId,
        teamId,
        projectId,
        isActive,
        roleId,
        workingDayInherit,
        workingTimings,
        dayOverrides,
      }) => $q((resolve, reject) => {
        $http.post(url,
          {
            userId,
            teamId,
            projectId,
            isActive,
            roleId,
            workingDayInherit,
            workingTimings,
            dayOverrides,
          })
          .then((response) => {
            resolve(response.data);
          }, reject);
      });

      const getAssignUserToTeamTemplate = ({ teamId }) => $q((resolve, reject) => {
        $http.get(`${url}/assing-user-to-team-template`, { params: { teamId } })
          .then((response) => {
            if (DEBUG) {
              console.log(response);
            }
            resolve(response.data);
          }, reject);
      });

      const getAssingTeamToUserTemplate = ({ groupId, userId }) => $q((resolve, reject) => {
        $http.get(`${url}/assing-team-to-user-template`, { params: { groupId, userId } })
          .then((response) => {
            if (DEBUG) {
              console.log(response);
            }
            resolve(response.data);
          }, reject);
      });

      const assingUserAndTeam = ({
        userId,
        teamId,
        projectId,
        isActive,
        roleId,
        workingDayInherit,
        workingTimings,
        dayOverrides,
      }) => $q((resolve, reject) => {
          $http.post(`${url}/assing-user-to-team`,
            {
              userId,
              teamId,
              projectId,
              isActive,
              roleId,
              workingDayInherit,
              workingTimings,
              dayOverrides,
            })
            .then((response) => {
              resolve(response.data);
            }, reject);
        });

      return {
        getUsers,
        getTeams,
        get,
        update,
        getAssignUserToTeamTemplate,
        getAssingTeamToUserTemplate,
        assingUserAndTeam
      };
    }])
  .name;

export default userInTeamService;




// WEBPACK FOOTER //
// ../services/configuration/user-in-team.service.js